import md5 from './md5';

export const emailOk = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());

export const url = (email, size = 160) => {
	const hash = md5(String(email).trim().toLowerCase());
	return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=identicon`;
};

/** Prefer explicit avatar, else Gravatar when email looks valid. */
export const src = (profile = {}, size = 160) => {
	if (profile.avatar) return profile.avatar;
	if (emailOk(profile.email)) return url(profile.email, size);
	return '';
};

export default {url, src, emailOk};
